import { PlusOutlined } from "@ant-design/icons";
import styled from "@emotion/styled";
import {
  Button,
  Col,
  Form,
  FormInstance,
  Input,
  Modal,
  Row,
  Space,
  Typography,
  message,
} from "antd";
import { Dispatch, FC, SetStateAction, useState } from "react";
import AgentAddressCardList from "./AgentAddressCardList";
import CreateAgentAddressForm from "./CreateAgentAddressForm";
import { AddressData } from "./interface/address.interface";
import {
  AddAddressDataInput,
  MasterDistrictData,
  MasterProvinceData,
  MasterSubDistrictData,
  OrderAddressData,
  UpdateAddressDataInput,
} from "services/interface";
import {
  useGetLocationType,
  useGetMasterDistrict,
  useGetMasterSubDistrict,
  useGetTransportType,
} from "hooks/useMasterData";
import UpdateAgentAddressForm from "./UpdateAgentAddressForm";
import { generateUUIDTemporay } from "utils/convertData";
import { useAddAddressData, useUpdateAddressData } from "hooks/useAgents";
import { useGetDeliveryPoint, useGetParkingTransportDistrictType, useGetParkingTransportProvinceType, useGetParkingTransportType } from "hooks/useShipping";
import { useAppSelector } from "store";

interface MainCreateAgentAddressProps {
  id?: string;
  form: FormInstance;
  masterProviceData: any;
  setDataAddress: Dispatch<SetStateAction<AddressData[]>>;
  dataAddress: AddressData[];
  handleRemoveItem?: (index: string) => void;
  searchOption?: boolean;
  addTemporary?: boolean;
  canSort?: boolean;
  refetchData?: () => void;
  personAddress?: OrderAddressData;
}

const formItemLayout = {
  labelCol: {
    xs: { span: 24 },
    sm: { span: 8 },
  },
  wrapperCol: {
    xs: { span: 24 },
    sm: { span: 16 },
  },
};

const MainCreateAgentAddress: FC<MainCreateAgentAddressProps> = ({
  id,
  form,
  searchOption,
  masterProviceData,
  setDataAddress,
  handleRemoveItem,
  dataAddress,
  refetchData,
  personAddress,
  addTemporary,
}) => {
  const [provinceId, setProvinceId] = useState<number>(0);
  const [districtId, setDistrictId] = useState<number>(0);

  const factoryId = useAppSelector(
    (state) => state.auth.profile?.user?.role?.ref_id
  );

  const { mutate: AddAddress, isPending: AddAddressIsLoading } =
    useAddAddressData();
  const { mutate: UpdateAddress, isPending: UpdateAddressIsLoading } =
    useUpdateAddressData();

  const { data: masterTransportData, isPending: transportLoading } =
    useGetTransportType();
  const { data: masterLocationData, isPending: locationLoading } =
    useGetLocationType();
  const { data: masterDistrictData, isPending: districtLoading } =
    useGetMasterDistrict(provinceId);
  const { data: masterSubDistrictData, isPending: subDistrictLoading } =
    useGetMasterSubDistrict(districtId);

  const limit = 40;
  const offset = 0;
  const search = "";

  const {
    data: deliveryPoint,
    isPending,
    refetch: getDPrefetch,
  } = useGetDeliveryPoint({
    district_id: districtId,
    province_id: provinceId,
    limit: limit,
    offset: offset,
    search: search,
    //factory_id: factoryId ?? "",
  });

  const [selectedLocation, setSelectedLocation] = useState<string>("");
  const [selectedLocationEdit, setSelectedLocationEdit] = useState<string>("");
  const [addressIdSelected, setAddressIdSelected] = useState<string>("");

  const [open, setOpen] = useState(false);
  const [edit, setEdit] = useState(false);

  const [formAddress] = Form.useForm();
  const [formEdit] = Form.useForm();
  const showDrawer = () => {
    setOpen(true);
  };

    // จังหวัดจุดส่งฟรี
    const { data: masterProviceFreeData, isLoading: proviceLoading } =
    useGetParkingTransportProvinceType({
      transport_type:
        selectedLocation || selectedLocationEdit || "transport_free",
      factory_id: factoryId || "",
    });

  // อำเภอฟรี
  const { data: masterDistrictFreeData, isLoading: districtFreeLoading } =
    useGetParkingTransportDistrictType({
      transport_type:
        selectedLocation || selectedLocationEdit || "transport_free",
      province_id: provinceId,
      factory_id: factoryId || "",
    });

  const {
    data: deliveryFreePoint,
    isLoading,
    refetch: getDFreePrefetch,
  } = useGetParkingTransportType({
    district_id: districtId,
    province_id: provinceId,
    transport_type:
      selectedLocation || selectedLocationEdit || "transport_free",
    factory_id: factoryId || "",
  });

  const changeDefault = (id: string) => {
    const targetAddress = dataAddress.find(
      (address) => address.address_id === id || address.temp_id === id
    );

    if (targetAddress) {
      const updatedData = dataAddress.map((address) => ({
        ...address,
        is_default: address.address_id === id || address.temp_id === id,
      }));

      setDataAddress(updatedData);
    }
  };
  const showEdit = (id: string) => {
    setEdit(true);
    const dataEdit = dataAddress.find(
      (item: AddressData) => item.address_id === id || item.temp_id === id
    );
    setAddressIdSelected(dataEdit?.address_id ?? dataEdit?.temp_id ?? "");
    const selectedTransport = masterTransportData?.find(
      (item) => item.key === dataEdit?.transport_type
    );
    setSelectedLocationEdit(selectedTransport?.key ?? "");
    setProvinceId(dataEdit?.province_id ?? 0);
    setDistrictId(dataEdit?.district_id ?? 0);
    console.log(dataEdit);
    formEdit.setFieldsValue({
      transport: dataEdit?.transport_type,
      province_id_ship: dataEdit?.province_id,
      address_name: dataEdit?.address_name,
      address_telephone: dataEdit?.address_telephone,
      line_1: dataEdit?.line_1,
      line_2: dataEdit?.line_2,
      location_type: dataEdit?.location_type,
      district_id_ship: dataEdit?.district_id,
      sub_district_id_ship: dataEdit?.sub_district_id,
      zip_code_ship: dataEdit?.post_code,
      remark: dataEdit?.address_remark,
      parking_id: dataEdit?.parking_id,
    });

    console.log(dataEdit?.parking_id);
  };

  const onUsingDefaultAddress = (formInput: FormInstance) => {
    const {
      firstname,
      lastname = "",
      telephone,
      email,
      province_id,
      address_text,
      district_id,
      sub_district_id,
      zip_code,
    } = form.getFieldsValue([
      "firstname",
      "lastname",
      "telephone",
      "email",
      "province_id",
      "address_text",
      "district_id",
      "sub_district_id",
      "zip_code",
    ]);

    const addressName = `${firstname} ${lastname}`.trim();
    setProvinceId(province_id);
    setDistrictId(district_id);
    formInput.setFieldsValue({
      province_id_ship: province_id,
      address_name: addressName,
      address_telephone: telephone,
      line_1: address_text,
      district_id_ship: district_id,
      sub_district_id_ship: sub_district_id,
      zip_code_ship: zip_code,
    });
    // if (addTemporary) {
    // const {
    //   firstname,
    //   lastname,
    //   telephone,
    //   email,
    //   province_id,
    //   address_text,
    //   district_id,
    //   sub_district_id,
    //   zip_code
    // } = form.getFieldsValue([
    //   "firstname",
    //   "lastname",
    //   "telephone",
    //   "email",
    //   "province_id",
    //   "address_text",
    //   "district_id",
    //   "sub_district_id",
    //   "zip_code"
    // ]);
    //   setProvinceId(province_id)
    //   setDistrictId(district_id);
    //   formInput.setFieldsValue({
    //     province_id_ship: province_id,
    //     address_name: `${firstname} ${lastname}`,
    //     address_telephone: telephone,
    //     line_1: address_text,
    //     district_id_ship: district_id,
    //     sub_district_id_ship: sub_district_id,
    //     zip_code_ship: zip_code,
    //   });
    // } else {
    //   setProvinceId(personAddress?.province_id ?? 0)
    //   setDistrictId(personAddress?.district_id ?? 0);
    //   formInput.setFieldsValue({
    //     province_id_ship: personAddress?.province_id,
    //     address_name: personAddress?.address_name,
    //     address_telephone: personAddress?.address_telephone,
    //     line_1: personAddress?.address_line_1,
    //     line_2: personAddress?.address_line_2,
    //     location_type: personAddress?.location_type,
    //     district_id_ship: personAddress?.district_id,
    //     sub_district_id_ship: personAddress?.sub_district_id,
    //     zip_code_ship: personAddress?.zip_code,
    //     remark: personAddress?.address_remark,
    //   });
    // }
  };

  const onCloseEdit = () => {
    setEdit(false);
    formEdit.resetFields();
    setSelectedLocationEdit("");
  };

  const onClose = () => {
    setOpen(false);
    formAddress.resetFields();
    setSelectedLocation("");
  };

  const handleSearchAddress = () => {};

  const onEdit = (values: any) => {
    const selectedDistrict = masterDistrictData?.find(
      (item: MasterDistrictData) => item.id === values.district_id_ship
    );
    const selectedSubDistrict = masterSubDistrictData?.find(
      (item: MasterSubDistrictData) => item.id === values.sub_district_id_ship
    );
    const selectedProvince = masterProviceData?.find(
      (item: MasterProvinceData) => item.id === values.province_id_ship
    );
    const editedAddress = dataAddress.map((address: AddressData) => {
      if (
        address.address_id === addressIdSelected ||
        address.temp_id === addressIdSelected
      ) {
        return {
          ...address,
          transport_type: values.transport,
          address_name: values.address_name,
          address_telephone: values.address_telephone,
          // address_detail: values.address_detail,
          district_id: values.district_id_ship,
          district_name: selectedDistrict?.name_th,
          province_id: values.province_id_ship,
          province_name: selectedProvince?.name_th,
          sub_district_id: values.sub_district_id_ship,
          sub_district_name: selectedSubDistrict?.name_th,
          post_code: values.zip_code_ship,
          address_taxno: values.address_taxno,
          line_1: values.line_1,
          line_2: values.line_2,
          location_type: values.location_type,
          address_text: values.address_text,
          parking_id: values?.parking_id,
        };
      }
      return address;
    });
    setDataAddress(editedAddress);

    const dataInput: UpdateAddressDataInput = {
      id: addressIdSelected,
      ref_id: id || "",
      ref_type: "agent",
      transport_type: values?.transport,
      address_type: "ship",
      address_name: values?.address_name,
      address_telephone: values?.address_telephone,
      line_1: values?.line_1,
      line_2: values?.line_2,
      district_id: values?.district_id_ship,
      province_id: values?.province_id_ship,
      sub_district_id: values?.sub_district_id_ship,
      post_code: values?.zip_code_ship,
      // address_taxno: values?.address_taxno,
      parking_id: values?.parking_id,
      location_type: values?.location_type,
      remark: values?.remark,
    };
    UpdateAddress(dataInput, {
      onSuccess: (res) => {
        if (res.status === "success") {
          message.success("แก้ไขที่อยู่ตัวแทนสำเร็จ");
          refetchData && refetchData();
        } else {
          message.error(`แก้ไขที่อยู่ตัวแทนไม่สำเร็จ: ${res.error_message}`);
        }
      },
      onError: (error) => {
        message.error(`แก้ไขที่อยู่ตัวแทนไม่สำเร็จ: ${error.message}`);
      },
    });

    setEdit(false);
  };
  const onFinish = (values: any) => {
    if (addTemporary) {
      const selectedDistrict = masterDistrictData?.find(
        (item: MasterDistrictData) => item.id === values.district_id_ship
      );
      const selectedSubDistrict = masterSubDistrictData?.find(
        (item: MasterSubDistrictData) => item.id === values.sub_district_id_ship
      );
      const selectedProvince = masterProviceData?.find(
        (item: MasterProvinceData) => item.id === values.province_id_ship
      );
      const data: AddressData = {
        temp_id: generateUUIDTemporay(),
        transport_type: values?.transport,
        address_type: "ship",
        address_name: values?.address_name,
        address_telephone: values?.address_telephone,
        line_1: values?.line_1,
        line_2: values?.line_2,
        district_id: values?.district_id_ship,
        district_name: selectedDistrict?.name_th,
        province_id: values?.province_id_ship,
        province_name: selectedProvince?.name_th,
        sub_district_id: values?.sub_district_id_ship,
        sub_district_name: selectedSubDistrict?.name_th,
        post_code: values?.zip_code_ship,
        address_taxno: values?.address_taxno,
        parking_id: values?.parking_id,
        location_type: values?.location_type,
        remark: values?.remark,
      };
      console.log(data);
      setDataAddress([...dataAddress, data]);
    } else {
      const dataInput: AddAddressDataInput = {
        ref_id: id ?? "",
        ref_type: "agent",
        transport_type: values?.transport,
        address_type: "ship",
        address_name: values?.address_name,
        address_telephone: values?.address_telephone,
        line_1: values?.line_1,
        line_2: values?.line_2,
        district_id: values?.district_id_ship,
        province_id: values?.province_id_ship,
        sub_district_id: values?.sub_district_id_ship,
        post_code: values?.zip_code_ship,
        parking_id: values?.parking_id,
        location_type: values?.location_type,
        remark: values?.remark,
      };

      AddAddress(dataInput, {
        onSuccess: (res) => {
          if (res.status === "success") {
            message.success("สร้างที่อยู่ตัวแทนสำเร็จ");
            refetchData && refetchData();
          } else {
            message.error(`สร้างที่อยู่ตัวแทนไม่สำเร็จ: ${res.error_message}`);
          }
        },
        onError: (error) => {
          message.error(`สร้างที่อยู่ตัวแทนไม่สำเร็จ: ${error.message}`);
        },
      });
    }
    onClose();
  };

  return (
    <>
      <FormWrapper>
        <HeadWrapper>
          <Typography.Text
            style={{
              fontWeight: 600,
              whiteSpace: "nowrap",
            }}
            underline
          >
            ที่อยู่ในการจัดส่ง
          </Typography.Text>
          <ButtonWrapper>
            {searchOption && (
              <Space.Compact>
                <Input
                  style={{ height: "32px" }}
                  placeholder="ค้นหาที่อยู่จัดส่ง"
                />
                <StyledButton type="primary" onClick={handleSearchAddress}>
                  ค้นหา
                </StyledButton>
              </Space.Compact>
            )}

          </ButtonWrapper>
        </HeadWrapper>
        <Row style={{ backgroundColor: "#FFFFFFFF" }}>
          <Col span={24}>
            <AgentAddressCardList
              dataAddress={dataAddress}
              form={form}
              setDataAddress={setDataAddress}
              handleRemoveItem={handleRemoveItem}
              showEdit={showEdit}
              // setRadio={setRadio}
              changeDefault={changeDefault}
              canUpdate={true}
              canSort={false}
              hideActionMenu={true}
            />
          </Col>
        </Row>
      </FormWrapper>
      <Modal
        title="สร้างที่อยู่จัดส่ง"
        open={open}
        maskClosable={false}
        onCancel={onClose}
        style={{ top: 20 }}
        footer={[
          <Button
            key="useAddress"
            onClick={() => {
              onUsingDefaultAddress(formAddress);
            }}
            disabled={!selectedLocation}
          >
            ใช้ที่อยู่เดียวกันกับข้อมูลตัวแทน
          </Button>,
          <Button key="back" onClick={onClose}>
            ยกเลิก
          </Button>,
          <Button
            key="submit"
            type="primary"
            onClick={() => formAddress.submit()}
          >
            ตกลง
          </Button>,
        ]}
      >
        <Form form={formAddress} {...formItemLayout} onFinish={onFinish}>
          <CreateAgentAddressForm
            form={formAddress}
            masterLocationData={masterLocationData}
            masterTransportData={masterTransportData}
            masterProviceData={masterProviceData}
            masterDistrictData={masterDistrictData}
            masterSubDistrictData={masterSubDistrictData}
            selectedLocation={selectedLocation}
            setSelectedLocation={setSelectedLocation}
            setProvinceId={setProvinceId}
            setDistrictId={setDistrictId}
            deliveryPointData={deliveryPoint}
            masterProviceFreeData={masterProviceFreeData}
            masterDistrictFreeData={masterDistrictFreeData}
            deliveryFreePoint={deliveryFreePoint}
          />
        </Form>
      </Modal>
      {/* Update Modal */}
      <Modal
        title="แก้ไขที่อยู่จัดส่ง"
        open={edit}
        maskClosable={false}
        onCancel={onCloseEdit}
        style={{ top: 20 }}
        footer={[
          <Button
            key="useAddress"
            onClick={() => {
              onUsingDefaultAddress(formEdit);
            }}
            disabled={!selectedLocationEdit}
          >
            ใช้ที่อยู่เดียวกันกับข้อมูลตัวแทน
          </Button>,
          <Button key="back" onClick={onCloseEdit}>
            ยกเลิก
          </Button>,
          <Button key="submit" type="primary" onClick={() => formEdit.submit()}>
            ตกลง
          </Button>,
        ]}
      >
        <Form form={formEdit} {...formItemLayout} onFinish={onEdit}>
          <UpdateAgentAddressForm
            form={formEdit}
            masterLocationData={masterLocationData}
            masterTransportData={masterTransportData}
            masterProviceData={masterProviceData}
            masterDistrictData={masterDistrictData}
            masterSubDistrictData={masterSubDistrictData}
            selectedLocation={selectedLocationEdit}
            setSelectedLocation={setSelectedLocationEdit}
            setProvinceId={setProvinceId}
            setDistrictId={setDistrictId}
            deliveryPointData={deliveryPoint}
            masterProviceFreeData={masterProviceFreeData}
            masterDistrictFreeData={masterDistrictFreeData}
            deliveryFreePoint={deliveryFreePoint}
          />
        </Form>
      </Modal>
    </>
  );
};

export default MainCreateAgentAddress;

const StyledButton = styled(Button)`
  margin-right: 5px;
`;
const ButtonWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  width: 100%;
  height: 100%;
`;

const HeadWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: 100%;
  padding: 0px 10px 0px 10px;
  margin-bottom: 10px;
  & > :first-child {
    flex: 3;
  }

  & > :last-child {
    flex: 7;
    display: flex;
    justify-content: flex-end;
  }
`;

const FormWrapper = styled.div`
  width: 100%;
  height: 100%;
  background-color: #ffffffff;
`;
